import React from 'react';
import YouTube from 'react-youtube';
import './peptHeader.css';

const PeptHeader = () => {

  return (
    <div className="pept__peptHeader section__padding" id="icd">
        <div className="pept__peptHeader-content">
            <h1 className="gradient__text">
                Demo Videos for Reprogramming ICDs
            </h1>
            <h2>
                The videos below demonstrate how to turn off ICDs from each of the ICD manufacturers.
            </h2>
            <p>
                Prior to ever turning off an ICD, remember to have an immediately available method to defibrillate the patient in the event of a dysrhythmia. This usually means having external defibrillation pads attached to the patient and connected to a defibrillator and in the hands of an anesthesia caregiver who is facile with the defibrillator.
            </p>
            <p>
                When selecting a video to watch, the key question to answer first is whether or not you need to convert the patient's pacer to asynchronous pacing. If you want to convert an Abbott/St Jude or Medtronic ICD to asynchronous pacing, you must first turn off the ICD's anti-tachy function. Neither device will allow you to convert to DOO or VOO with the ICD active.
            </p>
            <p>
                Turning off a Biotronik ICD is easy if you do not need to convert the device to DOO or VOO pacing—you simply push one button. If however you need to convert a Biotronik ICD to DOO or VOO pacing, you must turn off the ICD in a more prolonged manner, turning off each zone in the ICD parameters. The two videos will demonstrate this difference.
            </p>
            <p>
                Boston Scientific ICDs can be turned off in two ways, either turning off the defibrillator only or converting the ICD to the electrocautery safe mode. If the patient will have a DDD or VVI (or any demand mode), you will simply turn the defibrillator off. If you want to have the patient pace in DOO or VOO, you must use the electrocautery safe mode. The videos below will demonstrate these differences.
            </p>
        </div>
        <div className="pept__videos">
            <div className="video-wrapper">
                <div className="title-wrapper">
                    <h2>Abbott/SJM tachy therapy OFF and DOO pacing</h2>
                </div>
                <div className="video-content">
                    <YouTube videoId={"S3FM74Q-IzM"} />
                </div>
            </div>
            <div className="video-wrapper">
                <div className="title-wrapper">
                    <h2>Biotronik tachy therapy OFF</h2>
                </div>
                <div className="video-content">
                    <YouTube videoId={"P3ZH1GqLpeM"} />
                </div>
            </div>
            <div className="video-wrapper">
                <div className="title-wrapper">
                    <h2>Biotronik tachy therapy OFF and DOO pacing</h2>
                </div>
                <div className="video-content">
                    <YouTube videoId={"59F-1Tsux9Q"} />
                </div>
            </div>
            <div className="video-wrapper">
                <div className="title-wrapper">
                    <h2>Boston Sci tachy therapy OFF</h2>
                </div>
                <div className="video-content">
                    <YouTube videoId={"AlC2iFkxAsE"} />
                </div>
            </div>
            <div className="video-wrapper">
                <div className="title-wrapper">
                    <h2>Boston Sci tachy therapy OFF and DOO pacing</h2>
                </div>
                <div className="video-content">
                    <YouTube videoId={"Q8W68KY1wZA"} />
                </div>
            </div>
            <div className="video-wrapper">
                <div className="title-wrapper">
                    <h2>Medtronic tachy therapy OFF</h2>
                </div>
                <div className="video-content">
                    <YouTube videoId={"DdQUwxBkxF4"} />
                </div>
            </div>
            <div className="video-wrapper">
                <div className="title-wrapper">
                    <h2>Medtronic tachy therapy OFF and VOO pacing</h2>
                </div>
                <div className="video-content">
                    <YouTube videoId={"zLNh0NSUDZE"} />
                </div>
            </div>
        </div>
    </div>
  )
}

export default PeptHeader